import styles from '../styles/module/AboutComponent.module.css';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger"
import React, {useEffect} from "react";
import {googleMapsLink} from "./layout/Header.jsx";
export const imageContact1 = "assets/img/shutterstock_2002848872-Converted-01-scaled.jpg"
export const imageContact2 = "assets/img/contact-bg.jpg"
export const imageContact3 = "assets/img/shutterstock_2002848872-Converted-01-scaled.jpg"
const AboutComponent = (props) => {
    let {number = 1,handleClick,handleOpenLink} = props;
    // let animationString = "restart reverse restart restart"
    let animationString = "play none none none"
    let urls = [
        imageContact1,
        imageContact2,
        imageContact3,
    ]
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger)
        let scrollTrigger = {
            end: 'bottom center',
            start: 'top bottom',
            // markers:true,
            toggleActions: animationString
        }
        gsap.to(`.${styles.firstCard} .${styles.leftCard}`, 2.5, {  // Use styles here
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.firstCard}`},  // Use styles here
            x: 0,
            opacity: 1,
        })
        gsap.fromTo(`.${styles.firstCard} .${styles.leftCard} .content > *`, {  // Use styles here
            opacity: 0,
        }, {
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.firstCard}`},  // Use styles here
            opacity: 1,
            duration: 3,
            ease: "power3.inOut"
        })
        gsap.to(`.${styles.firstCard} .${styles.rightCard}`, 3.5, { // Use styles here
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.firstCard}`}, // Use styles here
            x: 0,
            opacity: 1,
        })

        gsap.to(`.${styles.secondCard} .${styles.leftCard}`, 2.5, { // Use styles here
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.secondCard}`}, // Use styles here
            x: 0,
            opacity: 1,
        })
        gsap.fromTo(`.${styles.secondCard} .${styles.leftCard} .content > * `, { // Use styles here
            opacity: 0,
        }, {
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.secondCard}`}, // Use styles here
            opacity: 1,
            duration: 3.5,
            ease: "power3.inOut"

        })
        gsap.to(`.${styles.secondCard} .${styles.rightCard}`, 3.5, {  // Use styles here
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.secondCard}`},  // Use styles here
            x: 0,
            opacity: 1,
        })
        gsap.to(`.${styles.thirdCard} .${styles.leftCard}`, 2.5, { // Use styles here
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.thirdCard} `}, // Use styles here
            x: 0,
            opacity: 1,
        })
        gsap.fromTo(`.${styles.thirdCard} .${styles.leftCard} .content > * `, {  // Use styles here
            opacity: 0,
        }, {
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.thirdCard}`},  // Use styles here
            opacity: 1,
            duration: 3,
            ease: "power3.inOut"
        })
        gsap.to(`.${styles.thirdCard} .${styles.rightCard}`, 3.5, {  // Use styles here
            scrollTrigger: {...scrollTrigger, trigger: `.${styles.thirdCard}`},  // Use styles here
            x: 0,
            opacity: 1,
        })

    }, [])
    switch (number) {
        case 2:
            return (
                <div className={styles.containerAbout}>
                    <div className={styles.wrapAbout}>
                        <div className={`${styles.about0card} ${styles.thirdCard}`}>
                            <div className={styles.leftCard}>
                                <div className="content">
                                    <p>
                                        Ob ein romantischer Abend zu zweit, eine ausgefallene Geburtstagsfeier oder ein
                                        seriöses
                                        Firmentreffen: Gao Restaurant macht jedes Erlebnis einzigartig.
                                    </p>
                                    <h2>
                                        WHEN FOOD IS MORE THAN JUST FOOD
                                    </h2>
                                    <p>
                                        Nimm dir eine Auszeit und erlebe eine einzigartige Komposition aus Aromen, Farben
                                        und
                                        Gerüchen auf die panasiatische Art. Wir freuen uns auf Dich!
                                    </p>
                                    <p>
                                        rofessioneller Service, eine edle Atmosphäre und unglaubliches Essen begeistern
                                        unsere
                                        Gäste.
                                    </p>
                                </div>
                            </div>
                            <div className={styles.rightCard}>
                                <div className="triangle triangle-1"></div>
                                <img src={urls?.[0]} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            );
        default:
            return (
                <div className={styles.containerAbout}>

                    <div className={styles.wrapAbout} id={"about-us"}>
                        <div className={`${styles.about0card} ${styles.firstCard}`}>

                            <div className={styles.leftCard}>
                                <div className={styles.content}>
                                    <div className={styles.orDivider}>
                                        <div className={styles.iconTitle}>
                                            <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                                 className=" "/>
                                        </div>
                                        <div className={styles.wrapOrDivider}>
                                            Über Uns
                                            <img src="/assets/icon/svg/separator.svg" alt=""/>
                                        </div>
                                    </div>
                                    <div className={styles.title}>
                                        Außergewöhnliche, kulinarische Erlebnisse
                                    </div>

                                    <div className="wrap-button">
                                        <div className={styles.paragraph}>
                                            Im Herzen von Leipzig vereint Kando die faszinierende Vielfalt asiatischer Aromen mit moderner Eleganz – ein Ort für außergewöhnliche kulinarische Erlebnisse.
                                        </div>
                                        <div className={styles.paragraph}>
                                            Unsere Leidenschaft für authentische indochinesische Küche und hochwertige, regionale Zutaten schafft ein Ambiente, das alle Sinne anspricht.
                                        </div>
                                        <div className={"wrap-btn"}>
                                            <button className="hover-filled-slide-right"
                                                    onClick={handleClick}>
                                                <span> Tisch reservieren</span>
                                            </button>
                                            <div className={"btn-img"}>
                                                <img src="/assets/images/Vector-2.png" alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.rightCard}>
                                <div className={`${styles.triangle} ${styles.triangle1}`}>
                                    <div className={styles.bgTriangle}>
                                    </div>
                                </div>
                                <img src={urls?.[1]} alt=""/>
                            </div>
                        </div>
                    </div>
                    <div className={styles.wrapAbout}>
                        <div className={`${styles.about0card} ${styles.secondCard}`}>
                            <div className={styles.rightCard}>
                                <div className={`${styles.triangle} ${styles.triangle2}`}>
                                    <div className={styles.bgTriangle}>
                                    </div>
                                </div>
                                <img src={urls?.[2]} alt=""/>
                            </div>
                            <div className={styles.leftCard}>
                                <div className={styles.content}>
                                    <div className={styles.orDivider}>
                                        <div className={styles.iconTitle}>
                                            <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                                 className=" "/>
                                        </div>
                                        <div className={styles.wrapOrDivider}>
                                            Unsere Story
                                            <img src="/assets/icon/svg/separator.svg" alt=""/>
                                        </div>
                                    </div>
                                    <div className={styles.title}>
                                        <h2>
                                            Dein LieblingsSushi - Deine vietnamesische Küche
                                        </h2>
                                    </div>
                                    <hr/>
                                    <div className={styles.paragraph}>

                                        Unser Restaurant befindet sich in <strong>
                                        <div className="stuff link" onClick={() => {
                                            window.open(googleMapsLink, "_blank");
                                        }}>Nikolaistraße 1, 04109 Leipzig</div>
                                    </strong>. Bei uns wird Ihnen leckeres Sushi,
                                        vietnamesische Spezialitäten servieren. Genießen Sie unsere Spezialitäten
                                        aus besten
                                        Zutaten.

                                    </div>
                                    <div className={"wrap-btn"}>
                                        <button className="hover-filled-slide-right"
                                                onClick={handleClick}>
                                            <span> Tisch reservieren</span>
                                        </button>
                                        <div className={"btn-img"}>
                                            <img src="/assets/images/Vector-2.png" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            )
    }

}
export default AboutComponent;